module.exports = __webpack_public_path__ + "static/media/web3-foundation.0e3fde0f.png";